export default __webpack_public_path__ + "static/media/4.ccf4bb92.jpg";